import type ElementBase from '@this/domain/element_base';
import TransportElement2 from '@this/domain/transport_element2';
import HotelElement2 from '@this/domain/hotel_element2';
import type Trip from '@this/domain/trip/trip2';
import Hotel2 from '@this/domain/hotel/hotel2';
import Transit2 from '@this/domain/transit/transit2';
import Flight2 from '@this/domain/flight/flight2';

class MarketLogHelper {
  static isElementMarketLogLinkAvailable(
    element: ElementBase | TransportElement2 | HotelElement2,
    themeServiceName: string,
    trip?: Trip
  ) {
    if (trip && trip.order?.orderItems.some(orderItem => orderItem.orderItemCategory === 'arrangement_request')) {
      return false;
    }
    if (element instanceof HotelElement2) {
      return !element.isPackage;
    }
    if (element instanceof TransportElement2) {
      if (element.isDomesticAir) return !element.isPackage;
      if (element.isForeignAir && themeServiceName !== 'マイナビBTM') return true;
      return false;
    }

    return false;
  }

  static elementMarketLogPath(element: ElementBase | TransportElement2 | HotelElement2, tripId: number) {
    return `/trips/${tripId}/market_log?element_id=${element.id}&element_type=${
      element instanceof TransportElement2 || element instanceof HotelElement2
        ? element.marketLogType
        : element.marketLogType()
    }`;
  }

  static isObjectMarketLogLinkAvailable2(object: Hotel2 | Transit2 | Flight2, serviceId: number) {
    if (object instanceof Hotel2) return !object.isPackage;
    if (object instanceof Flight2 && serviceId !== 2) return true;
    if (object instanceof Transit2) return object.air && !object.isRakutenPackage;
    return false;
  }

  static objectMarketLogPath2(object: Hotel2 | Transit2 | Flight2, priceIndex?: number | null) {
    let type = '';
    if (object instanceof Hotel2) {
      type = 'hotel';
    }
    if (object instanceof Transit2) {
      type = 'transport';
    }
    if (object instanceof Flight2) {
      type = 'transport';
    }

    let url = `/market_logs/${object.id}?element_type=${type}`;
    if (type === 'transport' && priceIndex !== null && priceIndex !== undefined) {
      url += `&price_index=${priceIndex}`;
    }
    return url;
  }
}

export default MarketLogHelper;
